import ListItemsType from "./ListItemsType";

interface QuickLink extends ListItemsType {
    title: string;
    description?: string;
    URL: string;
    iconURL?: string;
}

export const isQuickLink = (item: any): boolean => {
    let typedItem = (item as QuickLink)
    return  !!typedItem.URL && !!typedItem.title;
};

export default QuickLink;